/* légal : cookies + rétractation */
(function(){
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('[data-pw-cookies]');
    if(a&&window.privacyBanner&&typeof window.privacyBanner.showPreferences==='function'){e.preventDefault();window.privacyBanner.showPreferences();}
  });
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  var K='pw-retract-sum';
  document.addEventListener('submit',function(e){
    var f=e.target;if(!f||f.id!=='pw-retract')return;
    var now=new Date(),ts=now.toLocaleString('fr-FR',{dateStyle:'long',timeStyle:'short'});
    var h=f.querySelector('[data-pw-rts]');if(h)h.value=now.toISOString()+' ('+ts+')';
    var rows=[];f.querySelectorAll('label.pw2-field').forEach(function(l){var i=l.querySelector('input,textarea');if(i&&i.value.trim())rows.push([l.firstChild.textContent.trim(),i.value.trim()])});
    try{sessionStorage.setItem(K,JSON.stringify({ts:ts,rows:rows}))}catch(_){}
  },true);
  document.addEventListener('DOMContentLoaded',function(){
    var box=document.querySelector('[data-pw-rsum]');if(!box)return;
    var d=null;try{d=JSON.parse(sessionStorage.getItem(K)||'null')}catch(_){}
    if(!d)return;
    var w=document.querySelector('[data-pw-rwhen]');if(w)w.textContent=' le '+d.ts;
    box.innerHTML='<strong>Déclaration :</strong> je vous notifie par la présente ma rétractation du contrat portant sur la vente du ou des biens ci-dessous.<br>'+d.rows.map(function(r){return '<strong>'+esc(r[0])+' :</strong> '+esc(r[1])}).join('<br>');
  });
})();